module.exports = __webpack_public_path__ + "static/media/ring.653a27b6.svg";